<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Self Certification History</h4>
</div>
<div class="modal-body">
    <h2>Self Certification</h2>
    <p-table [value]="driverCommercialIntentHistory" styleClass="mvd_table--nest">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="4">
                    No Records Found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Certification Type</th>
                <th>Status</th>
                <th>Updated By</th>
                <th>Updated Date</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-expanded="expanded">
            <tr [pSelectableRow]="data">
                <td>{{ data.driverCommercialIntentTypeDisplayValue }}</td>
                <td>{{ data.driverCommercialIntentStatusTypeDisplayValue }}</td>
                <td>{{ data.updatedBy }}</td>
                <td>{{ data.updatedDate | shortDate }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" type="button" (click)="cancel()">Close</button>
    </div>
</div>